import { render, staticRenderFns } from "./gym.vue?vue&type=template&id=76148f48&scoped=true"
import script from "./gym.vue?vue&type=script&lang=js"
export * from "./gym.vue?vue&type=script&lang=js"
import style0 from "./gym.vue?vue&type=style&index=0&id=76148f48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76148f48",
  null
  
)

export default component.exports